"use client";

import dynamic from "next/dynamic";
import { renderNothingIfChunkFails } from "@/lib/optional-chunk";

export const SportsbookPreferencesDialog = dynamic(
  () =>
    renderNothingIfChunkFails(
      import("@/components/sportsbook-preferences/sportsbook-preferences-dialog").then(
        (mod) => mod.SportsbookPreferencesDialog,
      ),
    ),
  { ssr: false },
);
